import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import React from "react";

interface SnackBarComponentProps {
    message: string;
    severity: 'error' | 'warning' | 'info' | 'success';
    open: boolean;
    autoHideDuration?: number;
    onClose: () => void;
}

class SnackBarComponent extends React.Component<SnackBarComponentProps> {

    handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        this.props.onClose();
    };

    render() {
        const { open, message, severity } = this.props;
        return (
            <Snackbar
                open={open}
                autoHideDuration={this.props?.autoHideDuration || 6000}
                onClose={this.handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={this.handleClose}
                    severity={severity}
                >
                    {message}
                </Alert>
            </Snackbar>
        );
    }
}

export default SnackBarComponent;